import React from 'react';
import { Link } from 'react-router-dom';
import ServiceImage from '../components/ServiceImage';

const About = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'John O\'Sullivan',
      position: 'CEO & Founder',
      bio: 'With over 15 years of experience in software development and IT consulting, John founded OpiTech to help businesses leverage technology for growth.',
      image: '/images/team/john.jpg',
      social: {
        linkedin: 'https://linkedin.com/',
        twitter: 'https://twitter.com/'
      }
    },
    {
      id: 2,
      name: 'Sarah Murphy',
      position: 'CTO',
      bio: 'Sarah leads our technical team with her expertise in software architecture, cloud infrastructure, and emerging technologies.',
      image: '/images/team/sarah.jpg',
      social: {
        linkedin: 'https://linkedin.com/',
        github: 'https://github.com/'
      }
    },
    {
      id: 3,
      name: 'Michael Walsh',
      position: 'Creative Director',
      bio: 'Michael brings over a decade of experience in UI/UX design, brand strategy, and digital marketing to our creative projects.',
      image: '/images/team/michael.jpg',
      social: {
        linkedin: 'https://linkedin.com/',
        behance: 'https://behance.net/'
      }
    },
    {
      id: 4,
      name: 'Emily Chen',
      position: 'Lead Developer',
      bio: 'Emily specializes in front-end development with advanced skills in React, Angular, and innovative web technologies.',
      image: '/images/team/emily.jpg',
      social: {
        linkedin: 'https://linkedin.com/',
        github: 'https://github.com/'
      }
    },
    {
      id: 5,
      name: 'David Kelly',
      position: 'Mobile Development Lead',
      bio: 'David leads our mobile development team with expertise in iOS, Android, and cross-platform frameworks.',
      image: '/images/team/david.jpg',
      social: {
        linkedin: 'https://linkedin.com/',
        github: 'https://github.com/'
      }
    },
    {
      id: 6,
      name: 'Aoife Ryan',
      position: 'Project Manager',
      bio: 'Aoife ensures our projects are delivered on time and within budget while maintaining open communication with clients.',
      image: '/images/team/aoife.jpg',
      social: {
        linkedin: 'https://linkedin.com/'
      }
    }
  ];
  
  const technologies = [
    { category: 'Frontend', items: ['React', 'Angular', 'Vue.js', 'Next.js', 'TypeScript', 'HTML5/CSS3'] },
    { category: 'Backend', items: ['Node.js', 'PHP/Laravel', 'Python/Django', 'Java', '.NET', 'Ruby on Rails'] },
    { category: 'Mobile', items: ['React Native', 'Swift', 'Kotlin', 'Flutter', 'Ionic'] },
    { category: 'Databases', items: ['MongoDB', 'MySQL', 'PostgreSQL', 'Firebase', 'Redis'] },
    { category: 'Cloud & DevOps', items: ['AWS', 'Azure', 'Google Cloud', 'Docker', 'Kubernetes', 'CI/CD'] },
    { category: 'Design', items: ['Figma', 'Adobe XD', 'Sketch', 'Photoshop', 'Illustrator'] }
  ];
  
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>About OpiTech</h1>
          <p className="hero-description">
            We're a team of passionate tech enthusiasts dedicated to creating exceptional digital experiences.
          </p>
        </div>
      </section>
      
      {/* About Section */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            <div>
              <h2 className="text-gradient">Our Story</h2>
              <p>
                 OpiTech began with a simple mission: to help businesses harness the power of technology to achieve their goals. What started as a small team of developers working with local Irish businesses has grown into a full-service digital agency serving clients across Europe and beyond.
              </p>
              <p>
                Our journey has been shaped by a commitment to excellence, innovation, and client satisfaction. We believe in building lasting relationships with our clients, understanding their unique challenges, and delivering tailored solutions that drive real results.
              </p>
              <p>
                Today, OpiTech is proud to be a leading web and mobile development company in Ireland, with a diverse portfolio spanning various industries and technologies. Our team has expanded, but our core values remain the same: quality, innovation, and client success.
              </p>
            </div>
            <div>
            <ServiceImage 
                src="/images/about/office.jpg" 
                alt="OpiTech About" 
                title="OpiTech About"
              />
            </div>
          </div>
        </div>
      </section>
      
      {/* Values Section */}
      <section className="section" style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2>Our Core Values</h2>
            <div className="divider"></div>
          </div>
          
          <div className="grid grid-3">
            <div className="card" style={{ padding: '2rem' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3 className="mb-3">Innovation</h3>
              <p>
                We embrace new technologies and creative approaches to solve complex problems. Our team stays at the forefront of industry trends to deliver cutting-edge solutions.
              </p>
            </div>
            
            <div className="card" style={{ padding: '2rem' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-gem"></i>
              </div>
              <h3 className="mb-3">Quality</h3>
              <p>
                We're committed to excellence in everything we do. From clean code to stunning design, we maintain high standards to ensure our work stands the test of time.
              </p>
            </div>
            
            <div className="card" style={{ padding: '2rem' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-users"></i>
              </div>
              <h3 className="mb-3">Collaboration</h3>
              <p>
                We believe in working closely with our clients, treating their challenges as our own. True partnership leads to the best outcomes and most impactful solutions.
              </p>
            </div>
            
            <div className="card" style={{ padding: '2rem' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-rocket"></i>
              </div>
              <h3 className="mb-3">Impact</h3>
              <p>
                We focus on creating solutions that drive tangible results for our clients. Success is measured by the value and growth we help generate.
              </p>
            </div>
            
            <div className="card" style={{ padding: '2rem' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-book-open"></i>
              </div>
              <h3 className="mb-3">Continuous Learning</h3>
              <p>
                Technology never stands still, and neither do we. Our team is committed to ongoing education and professional development to deliver the best service.
              </p>
            </div>
            
            <div className="card" style={{ padding: '2rem' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3 className="mb-3">Integrity</h3>
              <p>
                We operate with transparency, honesty, and ethical practices. Building trust is fundamental to how we work with clients and each other.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Stats Section */}
      {/* <section className="section">
        <div className="container">
          <div className="about-stats">
            <div className="about-stat">
              <div className="about-stat-number">5+</div>
              <div className="about-stat-title">Years in Business</div>
            </div>
            
            <div className="about-stat">
              <div className="about-stat-number">50+</div>
              <div className="about-stat-title">Projects Completed</div>
            </div>
            
            <div className="about-stat">
              <div className="about-stat-number">30+</div>
              <div className="about-stat-title">Happy Clients</div>
            </div>
            
            <div className="about-stat">
              <div className="about-stat-number">20+</div>
              <div className="about-stat-title">Team Members</div>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* Team Section */}
      {/* <section className="section" style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2>Meet Our Team</h2>
            <div className="divider"></div>
            <p className="section-description">
              Our talented team of developers, designers, and digital strategists is the heart of OPITech.
              Each member brings unique skills and perspectives to create exceptional digital experiences.
            </p>
          </div>
          
          <div className="grid grid-3">
            {teamMembers.map(member => (
              <div key={member.id} className="team-member">
                <img src={member.image} alt={member.name} className="team-image" />
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-position">{member.position}</p>
                  <p style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>{member.bio}</p>
                  <div className="team-social">
                    {member.social.linkedin && (
                      <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="team-social-link">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    )}
                    {member.social.twitter && (
                      <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" className="team-social-link">
                        <i className="fab fa-twitter"></i>
                      </a>
                    )}
                    {member.social.github && (
                      <a href={member.social.github} target="_blank" rel="noopener noreferrer" className="team-social-link">
                        <i className="fab fa-github"></i>
                      </a>
                    )}
                    {member.social.behance && (
                      <a href={member.social.behance} target="_blank" rel="noopener noreferrer" className="team-social-link">
                        <i className="fab fa-behance"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-5">
            <Link to="/contact" className="btn">
              Join Our Team
            </Link>
          </div>
        </div>
      </section> */}
      
      {/* Technologies Section */}
      {/* <section className="section">
        <div className="container">
          <div className="text-center mb-5">
            <h2>Our Tech Stack</h2>
            <div className="divider"></div>
            <p className="section-description">
              We work with a wide range of technologies to deliver the best possible solutions for our clients.
              Our expertise spans across various platforms, languages, and frameworks.
            </p>
          </div>
          
          <div className="grid grid-2" style={{ gap: '2rem 4rem' }}>
            {technologies.map((tech, index) => (
              <div key={index}>
                <h3 className="mb-3" style={{ color: 'var(--secondary)' }}>{tech.category}</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {tech.items.map((item, i) => (
                    <span 
                      key={i} 
                      style={{ 
                        padding: '0.5rem 1rem', 
                        backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                        borderRadius: '2rem',
                        fontSize: '0.875rem'
                      }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      
      {/* Testimonials Section */}
      {/* <section className="section" style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2>What Our Clients Say</h2>
            <div className="divider"></div>
          </div>
          
          <div className="grid grid-3">
            <div className="testimonial-card">
              <p className="testimonial-content">
                "OPITech transformed our online presence with a stunning website and e-commerce platform. Sales have increased by 150% since launch!"
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  <img src="/images/testimonials/testimonial1.jpg" alt="Sarah O'Sullivan" />
                </div>
                <div className="testimonial-info">
                  <h4>Sarah O'Sullivan</h4>
                  <p>CEO, Dublin Retail Co.</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p className="testimonial-content">
                "The team at OPITech delivered our mobile app ahead of schedule and exceeded all our expectations. Their technical expertise is second to none."
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  <img src="/images/testimonials/testimonial2.jpg" alt="James Murphy" />
                </div>
                <div className="testimonial-info">
                  <h4>James Murphy</h4>
                  <p>Founder, HealthTrack Ireland</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p className="testimonial-content">
                "Working with OPITech was a game-changer for our business. Their custom software solution streamlined our operations and saved us thousands."
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  <img src="/images/testimonials/testimonial3.jpg" alt="Michael Kennedy" />
                </div>
                <div className="testimonial-info">
                  <h4>Michael Kennedy</h4>
                  <p>Operations Director, HomeBase Properties</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* Awards Section */}
      {/* <section className="section">
        <div className="container">
          <div className="text-center mb-5">
            <h2>Recognition & Awards</h2>
            <div className="divider"></div>
          </div>
          
          <div className="grid grid-3">
            <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-trophy"></i>
              </div>
              <h3 className="mb-2">Best Web Design Agency</h3>
              <p className="mb-2">Irish Digital Awards 2023</p>
            </div>
            
            <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-medal"></i>
              </div>
              <h3 className="mb-2">Top Mobile App Developer</h3>
              <p className="mb-2">European Tech Excellence 2022</p>
            </div>
            
            <div className="card" style={{ padding: '2rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2.5rem', color: 'var(--secondary)', marginBottom: '1rem' }}>
                <i className="fas fa-award"></i>
              </div>
              <h3 className="mb-2">Innovation in E-Commerce</h3>
              <p className="mb-2">Dublin Business Innovation 2021</p>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* CTA Section */}
      <section className="cta-section">
        <div className="container cta-content">
          <h2 className="cta-title">Ready to Work With Us?</h2>
          <p className="cta-description">
            Start your digital journey with OPITech today. Let's create something amazing together.
          </p>
          <Link to="/contact" className="btn btn-secondary">
            Get in Touch
          </Link>
        </div>
      </section>
    </>
  );
};

export default About;